/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as r from "react";
import { GridContext as n } from "../../GridClientWrapper.mjs";
const c = (t) => {
  const e = r.useContext(n);
  return /* @__PURE__ */ r.createElement(
    "colgroup",
    {
      ref: (o) => {
        e.columnResizeRef.current.colGroupMain = o, e.columnResizeRef.current.initWidths();
      }
    },
    t.children
  );
};
export {
  c as GridColGroup
};
